<main>
    <app-header2></app-header2>
    <app-banner2></app-banner2>
    <app-about2></app-about2>
    <app-jobs2></app-jobs2>
    <app-proyects2></app-proyects2>
    <app-more-proyects2></app-more-proyects2>
    <app-contact2></app-contact2>
    <app-footer2></app-footer2>
</main>